'use strict';
import * as $j_com$002eraquo$002elaminar$002emodifiers$002e$002dModifier$0024 from "./com.raquo.laminar.modifiers.-Modifier$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_Lcom_raquo_laminar_api_LaminarAliases__$init$__V($thiz) {
  $thiz.R5 = $j_com$002eraquo$002elaminar$002emodifiers$002e$002dModifier$0024.$m_Lcom_raquo_laminar_modifiers_Modifier$();
}
export { $f_Lcom_raquo_laminar_api_LaminarAliases__$init$__V as $f_Lcom_raquo_laminar_api_LaminarAliases__$init$__V };
